import { isNullable, isUndef } from '@aviata/type-guards';
import type { Airflow } from '@aviata/platform-types';

export function convertBaggage(baggage: Airflow.Segment.Baggage) {
  const entity = baggage.free.ADT ?? baggage.free.YTH;

  if (isNullable(entity)) {
    return null;
  }

  switch (entity.unit) {
    case 'KG':
      return `${entity.value} KG`;
    case 'PC': {
      if (isUndef(entity.pc)) {
        return `${entity.value} PC`;
      }

      const { pc } = entity;

      if (entity.value === 0) {
        return `${entity.value} ${pc.unit}`;
      }

      return entity.value > 1
        ? `${entity.value} x ${pc.value} ${pc.unit}`
        : `${pc.value} ${pc.unit}`;
    }
    default:
      return null;
  }
}
